<top-banner variant="custom">
    <h2 class="title mb-3">Asset Types</h2>
    <button type="button" (click)="toggleCreateAssetTypeModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>CREATE NEW ASSET TYPE</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table [value]="assetTypes" selectionMode="single" [(selection)]="selectedAssetType">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Name</th>
                    <th>Site Type</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-type>
                  <tr [pSelectableRow]="type">
                    <td><i class="fa fa-circle" aria-hidden="true" [style.color]="type.color"></i>&nbsp;{{ type.name }}</td>
                    <td>{{ type.siteType.name }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="2">No asset types found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Asset Type" [(visible)]="createAssetTypeModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createAssetTypeForm" (ngSubmit)="onCreateAssetTypeFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Category Color <i class="fa fa-circle" aria-hidden="true" [style.color]="selectedColor.value"></i></label><br />
          <p-dropdown
            class="form-control"
            [(ngModel)]="selectedColor"
            (ngModelChange)="onSelectedColorChange($event)"
            [ngModelOptions]="{ standalone: true }"
            [options]="defaultColors"
            optionLabel="label"
            [style]="{ width: '100%' }"
            filter="true"
          >
            <ng-template let-item pTemplate="color"> <i class="fa fa-circle" aria-hidden="true" [style.color]="item.label"></i>&nbsp;{{ item.label }} </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="col-md-12" *ngIf="siteTypes.length">
        <div class="form-group">
          <label>Select Site Type</label>
          <p-dropdown class="form-control" formControlName="siteType" [options]="siteTypes" optionLabel="label" [style]="{ width: '100%' }" filter="true"></p-dropdown>
        </div>
      </div>
      <div class="col-md-12" *ngIf="competencyTypes.length">
        <div>
          <label>Select Competencies</label>
          <select multiple class="form-control" formControlName="compTypes">
            <option *ngFor="let type of competencyTypes" [ngValue]="type">{{ type.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createAssetTypeModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateAssetTypeFormSubmit()" [disabled]="!createAssetTypeForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>
